module.exports = __webpack_public_path__ + "img/vertical_3_7_8003.608f3cb9.png";